import * as gsap from 'gsap'

import fade from '@/js/util/mixins/fade'
import slide from '@/js/util/mixins/slide'
// import scale from '@/js/util/mixins/scale'
// import rotate from '@/js/util/mixins/rotate'
// import custom from '.@/js/util/mixins/custom'

import tag from '@/js/util/props/tag'
import animationWrapper from '@/js/util/symbols/animationWrapper'

export default {
  inject: { animationWrapper },
  mixins: [
    fade,
    slide,
  ],
  props: {
    ...tag,
    options: {
      type: Object,
      default: () => ({}),
    },
    animationType: {
      type: String,
      default: 'fadeIn',
    },
  },

  data() {
    return {
      timeline: new gsap.TimelineMax(),
    }
  },

  mounted() {
    this[this.animationType]()
  },

  computed: {
    reverse() {
      return this.options.reverse
    },
    distance() {
      return this.options.distance || 100
    },
    scale() {
      return this.options.scale || 0.1
    },
    rotation() {
      return this.options.rotation || 45
    },
    opacity() {
      return `${this.options.opacity}` || 1
    },
    pause() {
      return this.options.pause ? null : 0
    },
    easeType() {
      return this.options.easeType || 'Power3'
    },
    easeMode() {
      return this.options.easeMode || 'easeInOut'
    },
    ease() {
      return gsap[this.easeType][this.easeMode] || gsap.Power1.easeInOut
    },
  },

  methods: {
    animation(type, ...attrs) {
      this.timeline[type](
        this.$el,
        this.options.duration || 1,
        ...attrs,
        this.options.delay || 0,
      )
    },

    animationFrom(...attrs) {
      this.animation('from', ...attrs)
    },
    animationTo(...attrs) {
      this.animation('to', ...attrs)
    },
    animationFromTo(...attrs) {
      this.animation('fromTo', ...attrs)
    },

    handleIsIntersecting(intersecting) {
      const { timeline } = this
      if (this.reverse) {
        return intersecting ? timeline.reverse() : timeline.play()
      }
      return intersecting ? timeline.play() : timeline.pause(this.pause)
    },
  },

  watch: {
    'animationWrapper.previousIsIntersecting': 'handleIsIntersecting',
  },

  render(createElement) {
    return createElement(this.tag, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseAnimationItem.js